 <template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="4" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nro Carga</label
              >
            </div>
          </b-col>
          <b-col sm="4" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal_cte"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nro DOC</label
              >
            </div>
          </b-col>
          <b-col sm="4" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_nf"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nro NF</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status_bip"
              :options="optionsStatusBip"
              track-by="value"
              label="label"
              placeholder="Status BIP"
              tag-placeholder=""
              select-label=""
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status_carga"
              :options="optionsStatusCarga"
              track-by="value"
              label="label"
              placeholder="Status Carga"
              tag-placeholder=""
              select-label=""
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão Inicial"
              v-model="dt_emi_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão Fim"
              v-model="dt_emi_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Dt Geração inicial"
              v-model="dt_carga_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Dt Geração Final"
              v-model="dt_carga_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Previsão Inicial"
              reset-button
              v-model="dt_pre_inicio"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Previsão Fim"
              reset-button
              v-model="dt_pre_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cnpj_origem"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CPF/CNPJ origem</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cnpj_des_red"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CPF/CNPJ {{ labelDesRed }}</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_operacao"
              :options="optionsTpOperacao"
              track-by="value"
              label="label"
              placeholder="Tipo operação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_processo"
              :options="optionsTpProcesso"
              track-by="value"
              label="label"
              placeholder="Tipo processo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="municipio_emi"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              placeholder="Município Emi."
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <multiselect
              v-model="uf_emi"
              :options="optionsUf"
              track-by="value"
              label="label"
              placeholder="UF Emi."
              tag-placeholder=""
              select-label=""
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="municipio_des_red"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              :placeholder="'Município ' + labelDesRed"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <multiselect
              v-model="uf_des_red"
              :options="optionsUf"
              track-by="value"
              label="label"
              :placeholder="'UF ' + labelDesRed"
              tag-placeholder=""
              select-label=""
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="unidade"
              :options="optionsUnidade"
              track-by="value"
              label="label"
              placeholder="Unidade"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="regiao"
              :options="optionsRegiao"
              track-by="value"
              label="label"
              placeholder="Região Despesa"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="4" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="observacao"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Observacao</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="3" class="p-0">
            <b-container>
              <b-col sm="6" md="6">
                <b-form-checkbox
                  v-model="redespacho"
                  value="1"
                  @input="ajustaLabel(redespacho)"
                  unchecked-value="2"
                >
                  Redespacho
                  <span
                    v-b-tooltip
                    title="Se marcado os filtros de Município e UF de destino passam a buscar dados de redespacho"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
              </b-col>
              <b-col sm="6" md="6">
                <b-form-checkbox
                  v-model="transferencia"
                  value="1"
                  unchecked-value="2"
                >
                  Transferência
                  <span
                    v-b-tooltip
                    title="Se marcado apenas cargas de transferência serão buscadas"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
              </b-col>
              <b-col sm="6" md="6">
                <b-form-checkbox
                    v-model="consulta_completa"
                    value="1"
                    unchecked-value="2"
                >
                  Consulta longa
                  <span
                      v-b-tooltip
                      title="Se marcado trará NFS importadas há mais de 60 dias"
                      placement="top"
                  >[?]</span
                  >
                </b-form-checkbox>
              </b-col>
            </b-container>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group"></div>
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="onEditarObs(null, null, null)"
                  :disabled="vuetableFilterButton"
                >
                  Recebimento MDFE
                </button>
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="onChecaMdfe()"
                    :disabled="vuetableFilterButton"
                >
                  Checar volumes MDFE
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <MontagemCargaMdfe ref="montagemcargamdfe"> </MontagemCargaMdfe>
      <MontagemCargaChecaMdfe ref="montagemcargachecamdfe"> </MontagemCargaChecaMdfe>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import MontagemCargaMdfe from "./MontagemCargaMdfe";
import MontagemCargaChecaMdfe from "./MontagemCargaChecaMdfe";

Vue.component("montagemcargamdfe", MontagemCargaMdfe);
Vue.component("montagemcargachecamdfe", MontagemCargaChecaMdfe);

export default {
  components: {
    Multiselect,
    MontagemCargaMdfe,
    MontagemCargaChecaMdfe,
  },
  data() {
    return {
      helpForm: new Form({ params: [], search: "" }),
      isLoadingTransportadora: false,
      dt_emi_ini: "",
      dt_emi_fim: "",
      num_carga: "",
      num_nf: "",
      consulta_completa: "",
      dt_pre_fim: '',
      dt_pre_inicio: '',
      redespacho: 2,
      transferencia: 2,
      labelDesRed: "Destinatário",
      num_fiscal_cte: "",
      dt_emi_ini_label: "",
      dt_emi_fim_label: "",
      dt_carga_ini_label: "",
      dt_carga_fim_label: "",
      dt_carga_ini: "",
      dt_carga_fim: "",
      cnpj_origem: "",
      observacao: "",
      status_carga: [],
      status_bip: [],
      tp_operacao: [],
      tp_processo: [],
      municipio_emi: [],
      unidade: [],
      municipio_des_red: [],
      regiao: [],
      uf_emi: [],
      uf_des_red: [],
      cnpj_des_red: "",
      optionsUf: [],
      optionsStatusCarga: [],
      optionsTpOperacao: [],
      optionsTpProcesso: [],
      optionsStatusBip: [],
      optionsMunicipio: [],
      optionsUnidade: [],
      optionsRegiao: [],
      data_filter: [],
    };
  },
  mounted() {
    this.$events.$on("load-json", (e) => this.carregaJson());
    this.redespacho = 2;
    this.transferencia = 2;
    this.consulta_completa = 2;
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_emi_ini_label = this.dt_emi_ini;
      this.dt_emi_fim_label = this.dt_emi_fim;
      this.dt_emi_ini = this.formatDateSubmit(this.dt_emi_ini);
      this.dt_emi_fim = this.formatDateSubmit(this.dt_emi_fim);
      this.dt_pre_ini_label = this.dt_pre_inicio;
      this.dt_pre_fim_label = this.dt_pre_fim;
      this.dt_pre_inicio = this.formatDateSubmit(this.dt_pre_inicio);
      this.dt_pre_fim = this.formatDateSubmit(this.dt_pre_fim);
      this.dt_carga_ini_label = this.dt_carga_ini;
      this.dt_carga_fim_label = this.dt_carga_fim;
      this.dt_carga_ini = this.formatDateSubmit(this.dt_carga_ini);
      this.dt_carga_fim = this.formatDateSubmit(this.dt_carga_fim);
      this.data_filter = {
        dt_emi_ini: this.dt_emi_ini,
        dt_emi_fim: this.dt_emi_fim,
        dt_carga_ini: this.dt_carga_ini,
        dt_carga_fim: this.dt_carga_fim,
        consulta_completa: this.consulta_completa,
        dt_pre_inicio: this.dt_pre_inicio,
        dt_pre_fim: this.dt_pre_fim,
        unidade: this.unidade,
        regiao: this.regiao.value,
        cnpj_origem: this.cnpj_origem,
        observacao: this.observacao,
        num_carga: this.num_carga,
        num_nf: this.num_nf,
        redespacho: this.redespacho,
        transferencia: this.transferencia,
        num_fiscal_cte: this.num_fiscal_cte,
        status_carga: this.status_carga,
        status_bip: this.status_bip,
        cnpj_des_red: this.cnpj_des_red,
        municipio_emi: this.municipio_emi,
        municipio_des_red: this.municipio_des_red,
        uf_emi: this.uf_emi,
        uf_des_red: this.uf_des_red,
        tp_processo: this.tp_processo,
        tp_operacao: this.tp_operacao,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_emi_ini = this.dt_emi_ini_label;
      this.dt_emi_fim = this.dt_emi_fim_label;
      this.dt_carga_ini = this.dt_carga_ini_label;
      this.dt_carga_fim = this.dt_carga_fim_label;
      this.dt_pre_inicio = this.dt_pre_ini_label;
      this.dt_pre_fim = this.dt_pre_fim_label;
    },
    resetFilter() {
      this.num_carga = "";
      this.num_nf = "";
      this.num_fiscal_cte = "";
      this.status_bip = "";
      this.status_carga = "";
      this.dt_emi_ini = "";
      this.dt_emi_fim = "";
      this.dt_carga_ini = "";
      this.consulta_completa = "";
      this.dt_carga_fim = "";
      this.dt_pre_inicio = "";
      this.dt_pre_fim = "";
      this.cnpj_origem = "";
      this.observacao = "";
      this.cnpj_des_red = "";
      this.tp_operacao = "";
      this.tp_processo = "";
      this.municipio_emi = "";
      this.uf_emi = "";
      this.municipio_des_red = "";
      this.uf_des_red = "";
      this.unidade = "";
      this.redespacho = "";
      this.regiao = "";
      this.transferencia = "";
      this.$events.fire("filter-reset");
    },
    carregaJson() {
      this.$parent.optionsMunicipio.forEach((obj) => {
        this.optionsMunicipio.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsUf.forEach((obj) => {
        this.optionsUf.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsStatusCarga.forEach((obj) => {
        this.optionsStatusCarga.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsStatusBip.forEach((obj) => {
        this.optionsStatusBip.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsTpOperacao.forEach((obj) => {
        this.optionsTpOperacao.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsTpProcesso.forEach((obj) => {
        this.optionsTpProcesso.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsUnidade.forEach((obj) => {
        this.optionsUnidade.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsRegiao.forEach((obj) => {
        this.optionsRegiao.push({ label: obj.label, value: obj.value });
      });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ),
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.cpf,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.cuit,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    ajustaLabel(destino_redespacho) {
      if (destino_redespacho == 1) {
        this.labelDesRed = "Redespacho";
      } else {
        this.labelDesRed = "Destinatário";
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onEditarObs(data) {
      this.$refs.montagemcargamdfe.onEdit();
    },
    onChecaMdfe() {
      this.$refs.montagemcargachecamdfe.onCreate();
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
